import React from "react";
import { Link } from "react-router-dom";

const SidebarLink = ({
  to,
  icon: Icon,
  label,
  isActive,
  disabled = false,
  color = "#000",
}) => {
  return (
    <li
      className={`sidebar-link-item ${disabled ? "disabled" : ""}`}
      style={{ position: "relative" }}
    >
      {disabled ? (
        <>
          <div className="sidebar-link disabled-link">
            <Icon color="#999" />
            <span>{label}</span>
            <div className="sidebar_tooltip">Upgrade plan to use this feature</div>
          </div>
        </>
      ) : (
        <Link to={to} className={isActive ? "active" : ""}>
          <Icon color={color} />
          <span>{label}</span>
        </Link>
      )}
    </li>
  );
};

export default SidebarLink;
